import React from "react"
import cx from "classnames"

import { ArticleCard } from "../../components"
import { GraphCms_Article } from "../../../../graphql-types"

type Props = {
  className?: string
  articles: GraphCms_Article[]
}

function ArticleList({ className, articles }: Props) {
  return (
    <ul className={cx(className)}>
      {articles.map((n: GraphCms_Article) => {
        return (
          <li key={n.id} className="mb-12">
            <ArticleCard article={n} />
          </li>
        )
      })}
    </ul>
  )
}

export default ArticleList
